<template>
  <li class="anz-mb-xxs">
    <a-button
      add-href
      :href="href"
      className="anz-link anz-flex anz-align-items-center anz-bg-white anz-py-xs anz-px-s anz-font-default anz-fs-13 anz-lh-145"
    >
      <template #title>
        <strong class="anz-strong anz-flex-fill anz-mr-xs">
          <slot name="content-title"></slot>
        </strong>
        <span class="anz-ml-auto">
          <slot name="content-value"></slot>
        </span>
        <a-icon
          name="arrow-right"
          width="0.7142em"
          height="0.7142em"
          class-name="anz-color-black-50 anz-ml-xs anz-mt-xxs"
          :style="{ opacity: '0.4' }"
        />
      </template>
    </a-button>
  </li>
</template>

<script>
import AButton from '@/components/Forms/AButton'
import AIcon from '@/components/AIcon'
export default {
  name: 'ASectionListItem',
  components: { AIcon, AButton },
  props: {
    href: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped></style>
